import { createContext, useContext } from 'react';
import { baseKeys } from '../../../../Lib/Hooks/MetadataService/useGetMetaDatas';

/**
 * Custom context for Vendor Catalog Item Details Form.
 */
export const ItemDetailsFormContext = createContext<{
  /**
   * Returns true if the field is disabled based `attributes_required`
   * with the division, department, category, class, and field name as a key
   *
   * @param field - The field name
   * @param defaultValue - The default value to return if the field is not found
   * @returns true if the field is disabled, false otherwise
   */
  isFieldDisabled: (field: string, defaultValue: boolean) => boolean;
  /**
   * Returns true if the field is required based `attributes_required`
   * with the division, department, category, class, and field name as a key
   *
   * @param field - The field name
   * @param defaultValue - The default value to return if the field is not found
   * @returns true if the field is required, false otherwise
   */
  isFieldRequired: (field: string, defaultValue: boolean) => boolean;
  /**
   * Returns an array of options from either the metadata based on the metaDataKey
   * or from `ns_master_fieldListOptionsPerMerchCategory` if fieldsListKey is provided and `ns_master_fieldListOptionsPerMerchCategory`
   * as a match for the selected division, department and category.
   *
   * @param metaDataKey - The meta data key
   * @param fieldsListKey - The fields list key
   * @returns an array of options
   */
  makeOptionsFromMetaData: (
    metaDataKey: (typeof baseKeys)[number],
    fieldsListKey?: string,
  ) => Array<{ label: string; value: string }>;
}>({
  isFieldDisabled: () => false,
  isFieldRequired: () => false,
  makeOptionsFromMetaData: () => [],
});
export const useItemDetailsForm = () => useContext(ItemDetailsFormContext);
